import { VehicleStatusEnum } from '@/services/api-clients';

export function vehicleStatusIconFilter(status: VehicleStatusEnum) {
  switch (status) {
    case VehicleStatusEnum.Available: return 'mdi-check';
    case VehicleStatusEnum.Busy: return 'mdi-close';
    case VehicleStatusEnum.ReceivingFromWorkshop: return 'mdi-wrench-clock';
    case VehicleStatusEnum.InWorkshop: return 'mdi-hammer-wrench';
    case VehicleStatusEnum.Theft: return 'mdi-circle-off-outline';
    default: return '';
  }
}
